import { ReducerCreators, current } from '@reduxjs/toolkit';
import { eaptekaApiRequestRecommendationProductsGet } from '../../services/eaptekaApi';
import { ProductCommonCartProps } from '../products/types';
import { ProductId } from '../types';
import {
  RecommendationProducts,
  RecommendationProductsStoreState
} from './types';
import {
  OnAfterRecommendationProductAdd,
  RecommendationProductAddedSuccessfully
} from '../../services/dispatchers';

export default (
  create: ReducerCreators<RecommendationProductsStoreState>
) => ({
  fetchRecommendationProducts: create.asyncThunk<
    RecommendationProducts,
    ProductId[]
  >(
    async (
      products,
      thunkApi
    ): Promise<RecommendationProducts> => {
      try {
        return await eaptekaApiRequestRecommendationProductsGet(
          { products }
        );
      } catch (error) {
        throw thunkApi.rejectWithValue({
          message: error.message
        });
      }
    },
    {
      pending: (state) => {
        state.loading = 'pending';
      },
      rejected: (state, { error }) => {
        state.loading = 'failed';
        state.error = error;
      },
      fulfilled: (state, { payload }) => {
        state.loading = 'succeeded';
        state.productsBond = payload.productsBond;
        state.entities = payload.recommendationProducts;
        state.ids = Object.keys(
          payload.recommendationProducts
        );
      }
    }
  ),
  addToCart: create.reducer<ProductCommonCartProps>(
    (
      state: RecommendationProductsStoreState,
      { payload }
    ) => {
      const { id, newQuantity } = payload;
      const product = current(state).entities[id];

      RecommendationProductAddedSuccessfully.dispatch({
        product,
        newQuantity
      });
      OnAfterRecommendationProductAdd.dispatch({
        ...product,
        ...{ quantity: newQuantity }
      });
    }
  )
});
